module.exports = __webpack_public_path__ + "img/substack-white.d758b1b4.svg";